/**
 * Base skeleton component with shimmer animation.
 * Uses semantic color tokens for consistent styling.
 */
export interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className = '' }: SkeletonProps) => {
  return <div className={`bg-muted animate-pulse rounded ${className}`} aria-label="Loading..." />;
};
